import { useLocation, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-100">
      <Navbar />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="flex max-w-lg flex-col items-center text-center">
          <span className="flex h-20 w-20 items-center justify-center rounded-full bg-primary-100 text-4xl text-primary-500">
            <i className="ri-compass-3-line" />
          </span>
          <p className="mt-6 font-label text-6xl font-black text-primary-200">404</p>
          <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h1>
          <p className="mt-3 text-sm text-foreground-500">
            您访问的页面不存在或已被移除：
            <span className="ml-1 font-label text-foreground-700">{location.pathname}</span>
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/news"
              className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-newspaper-line" />
              浏览资讯
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}